import get from 'lodash/get';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';
import { TMaterialFormState } from 'pages/surface/store/hooks/material';
import { TData, TExtendedSurfaceItem } from 'entries/common/widgets/context';
import { LayingTypeLabel } from 'pages/common/components/LayingTypeField/const';
import { Inputs } from '../types';
import { SurfaceInputs } from '../../surface/types';

type TFormParams = {
  data: Inputs;
  surfaces: {
    state: SurfaceInputs;
    data: TExtendedSurfaceItem[];
  };
  materials: TMaterialFormState;
  productData?: TData | null;
};

type TSurface = {
  [key: string]: {
    baseSurface?: SelectionGroupValue | null;
    typeInstallation?: SelectionGroupValue | null;
  };
};

const formatValue = (value: string | null): number | null => {
  if (!value) {
    return null;
  }
  return Number(value.replace(/,/g, '.'));
};

export const getFormBody = ({ data, surfaces, materials, productData }: TFormParams) => {
  const areaUser = get(data, 'area', null);
  const length = get(data, 'length', null);
  const width = get(data, 'width', null);
  const height = get(data, 'height', null);
  const layerThickness = get(data, 'layerThickness', null);

  return {
    inputParameters: {
      ...(!!areaUser && { areaUser: formatValue(areaUser) }),
      ...(!!length && { length: formatValue(length) }),
      ...(!!width && { width: formatValue(width) }),
      ...(!!height && { height: formatValue(height) }),
      ...(!!layerThickness && { layerThickness: formatValue(layerThickness) }),
    },
    ...((!!data?.doors || !!data.doorsFields) && {
      doors: {
        quantity: formatValue(get(data, 'doors', null)),
        sizes: !!data.doorsFields?.length
          ? data.doorsFields.map(door => ({
              ...door,
              height: formatValue(door.height),
              width: formatValue(door.width),
            }))
          : null,
      },
    }),
    ...((!!data?.windows || !!data.windowsFields) && {
      windows: {
        quantity: formatValue(get(data, 'windows', null)),
        sizes: !!data.windowsFields?.length
          ? data.windowsFields.map(window => ({
              ...window,
              height: formatValue(window.height),
              width: formatValue(window.width),
            }))
          : null,
      },
    }),
    surface: getSurface({ data, surfaces, materials }),
    complimentaryProducts: productData?.surfaces?.complimentaryProducts.length
      ? productData?.surfaces?.complimentaryProducts
      : [],
    regionId: productData?.regionId || '',
    mainProductCalculatorId: productData?.surfaces?.id ?? '',
  };
};

const getSurface = ({ data: formData, surfaces, materials }: TFormParams) => {
  const surface: TSurface = {};
  surfaces.data.forEach(surfaceItem => {
    if (!surfaces.data.length) {
      return;
    }
    const baseSurface = materials[surfaceItem.name]?.value;
    const foundedSurface = surfaces.data.find(surf => surf.name === surfaceItem.name);

    const surfaceName = surfaceItem.name.toUpperCase();

    if (!baseSurface && (!foundedSurface?.typeInstallation || !formData.thickness)) {
      if (surfaces.state[surfaceItem.name]) {
        surface[surfaceName] = {};
      }
      return;
    }

    surface[surfaceName] = {
      ...(!!baseSurface && { baseSurface }),
      ...(!!foundedSurface?.typeInstallation && {
        typeInstallation: LayingTypeLabel[formData.thickness as 'horizontal' | 'diagonal'],
      }),
    };
  });
  return surface;
};
